import type { DataTypeLocator } from '@helo/cms'

import { Options } from '../Options'

const dataTypeLocatorOfType = Options.scalar<DataTypeLocator>('DataTypeLocator')

export const queryOptions = Options.asRecord(
  Options.createOption({
    key: 'queryId',
    inputKind: 'text',
    required: true,
    label: 'Query ID',
    description: 'Id of the registered query to resolve from the store.',
    category: 'Query',
  }),
  Options.createOption({
    key: 'contentNodeLocator',
    inputKind: 'data_type_locator',
    ofType: dataTypeLocatorOfType,
    label: 'Content node locator',
    description: 'Locator for the query content node used as chart data.',
    category: 'Query',
  }),
)

export interface QueryOptions extends Options.TypeOf<typeof queryOptions> {}
